import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import { process } from "@progress/kendo-data-query";
import {
  Grid,
  GridColumn as Column,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import Api from "../../Services/Api";
import ImpactEditComponent from "../Tenant/Component/ImpactEditComponent";
import * as moment from "moment";
import { formatNumber } from "@telerik/kendo-intl";
import { CircularProgress } from "@material-ui/core";
import { Popup } from "@progress/kendo-react-popup";
import "hammerjs";
import { Dropdown } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import AddToCart from "../Tenant/AddToCart";
import RiskColumns from "../Tenant/RiskColumns.json";
import SkeletonReport from "../Dashboard/SkeletonReport";
import TextNarrative from "../Dashboard/TextNarrative";
import TextNarrativeExport from "../Dashboard/TextNarrativeExport";
import ReportUpdate from "../Dashboard/ReportUpdate";
export default class DataReportForTasks extends Component {
  gridPDFExport;
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      dataState: {
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
        take: 15,
        skip: 0,
      },
      loader: false,
      taskList: [],
      emailId: "",
      message: "",
      projectHomeFlag: false,
      openPdfTitlePopup: false,
      title: "",
      showAddToCart: false,
      isReportLoaded: false,
      chartData: {},
      impactMaster: [],
    };
    this._exporterRisk = React.createRef();
  }

  componentDidUpdate() {}
  componentDidMount = () => {
    if (
      this.props.dashboardId &&
      this.props.reportId &&
      !this.props.chartInputs
    ) {
      this.fetchReportsByPagination(
        this.props.dashboardId,
        this.props.reportId
      );
    } else {
      this.setState({
        chartData: this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded: true,
      });
      this.init(this.props.chartInputs);
    }
  };
  fetchReportsByPagination = async (dashboardId, reportId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        WidgetListIds: [reportId],
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        this.setState({
          chartData: response.chartData[0],
          isReportLoaded: true,
        });
        this.init(response.chartData[0]);
        this.props.updateResponse(reportId, response.chartData[0]);
      } else {
        this.setState({
          chartData: {},
          isReportLoaded: true,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        chartData: {},
        isReportLoaded: true,
      });
    }
  };
  init = async (chartData) => {
    if (chartData?.taskDataset?.taskRegisters) {
      let taskRegister = chartData?.taskDataset?.taskRegisters || [];
      taskRegister.map((riskReg) => {
        if (riskReg.originalCompletionDate) {
          riskReg.originalCompletionDate = riskReg.originalCompletionDate
            ? moment(new Date(riskReg.originalCompletionDate)).format(
                "DD-MMM-YYYY"
              )
            : null;
        }
        if (riskReg.projectedCompletionDate) {
          riskReg.projectedCompletionDate = riskReg.projectedCompletionDate
            ? moment(new Date(riskReg.projectedCompletionDate)).format(
                "DD-MMM-YYYY"
              )
            : null;
        }
        if (riskReg.actualCompletionDate) {
          riskReg.actualCompletionDate = riskReg.actualCompletionDate
            ? moment(new Date(riskReg.actualCompletionDate)).format(
                "DD-MMM-YYYY"
              )
            : null;
        }
        if (riskReg.proximityAlertDate) {
          riskReg.proximityAlertDate = riskReg.proximityAlertDate
            ? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY")
            : null;
        }
        if (riskReg.updatedDate) {
          var time = moment(riskReg.updatedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let updatedDate = time;
          riskReg.updatedDate = riskReg.updatedDate
            ? moment(new Date(updatedDate)).format("DD-MMM-YYYY")
            : "";
        }
        if (riskReg.createdDate) {
          let time = moment(riskReg.createdDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let createdDate = time;
          riskReg.createdDate = riskReg.createdDate
            ? moment(new Date(createdDate)).format("DD-MMM-YYYY")
            : "";
        }
        if (riskReg.closedDate) {
          let time = moment(riskReg.closedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let closedDate = time;
          riskReg.closedDate = riskReg.closedDate
            ? moment(new Date(closedDate)).format("DD-MMM-YYYY")
            : "";
        }

        if (riskReg.riskAlertStakeHolders) {
          riskReg["riskAlertStakeHolders"] =
            riskReg["riskAlertStakeHolders"].toString();
        }

        if (riskReg.isClosed === false) {
          riskReg.isClosed = "Open";
        } else {
          riskReg.isClosed = "Closed";
        }
        if (riskReg.isApproved === false) {
          riskReg.isApproved = "No";
        } else {
          riskReg.isApproved = "Yes";
        }
      });
      // let impactMaster = [];
      // if (taskRegister && taskRegister.length > 0) {
      //   impactMaster = taskRegister[0].impactResponse;
      // }
      // this.setState({ ...this.state, impactMaster: impactMaster });
      await this.createDynamicDropdowns(taskRegister);
      // await this.createDynamicCols(taskRegister);

      var taskData = taskRegister.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );

      this.setState({
        ...this.state,
        taskList: taskData,
        loader: false,
        chartData: this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded: true,
      });
    }
  };

  createDynamicDropdowns = async (products) => {
    try {
      let dropdownColumn = [];
      products.map((res, i) => {
        res.customFields &&
          res.customFields.map((item, j) => {
            if (dropdownColumn.length > 0) {
              if (
                !dropdownColumn.find((cf) => cf.fieldName === item.fieldName)
              ) {
                dropdownColumn.push({
                  fieldName: item.fieldName,
                  data: this.getCustomFieldMasterData(item.fieldName),
                  inputType: this.getInputType(item.fieldName),
                });
              }
            } else {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName),
                inputType: this.getInputType(item.fieldName),
              });
            }
          });
      });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                let hashArr = this.stringToHashForCF(val, col.data);
                res[col.fieldName] = hashArr;
              } else if (temp.inputType === "Single Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val = temp.multiText ? temp.multiText : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val = temp.multiText ? parseInt(temp.multiText) : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val = temp.multiText ? new Date(temp.multiText) : "";
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
          />
        ));
      }
      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {
      console.log(err);
    }
  };

  getInputType = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name === item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name === stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }

  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue) {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };

  getCustomFieldMasterData = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster.filter(
        (item) => item.fieldName === fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: false,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };

  //Impact
  createDynamicCols = async (products) => {
    let impactColumn = [];

    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name + "_" + item.type)) {
              impactColumn.push(item.name + "_" + item.type);
            }
          } else {
            impactColumn.push(item.name + "_" + item.type);
          }
        });
      }
    });
    // impactColumn.sort();
    // impactColumn.reverse();
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          let temp = res.impactResponse.filter(
            (item) => item.name + "_" + item.type === col
          );
          if (temp.length > 0) {
            res[col] =
              temp[0].type == "Post" ? temp[0].postImpactValue : temp[0].value;
          } else {
            res[col] = undefined;
          }
        });
      });
    }

    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <Column
          field={item}
          title={this.getImpactUnit(item)}
          width="100px"
          editable={false}
          cell={(props) => (
            <ImpactEditComponent {...props} onEditCell={this.onEditCell} />
          )}
          filter={"numeric"}
        />
      ));
    }
    this.setState({ ...this.state, impactColumns: columnsToShow });
  };

  getImpactUnit = (impact) => {
    var impactTemp = this.state.impactMaster.find(
      (item) => item.name + "_" + item.type === impact
    );
    var res = impact;
    if (impactTemp && impactTemp.name) {
      let unit = impactTemp.units ? impactTemp.units : "";
      res = impactTemp.name + " / " + unit + " (" + impactTemp.type + ")";
    }
    return res;
  };

  mitigationFilterQuery() {}

  changeLineChartWidth = (widgetId) => {
    this.props.changeLineChartWidth(widgetId);
  };
  selectedDB = (data) => {
    this.props.selectedDB(data);
  };

  openAddToCart(data) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: "Task",
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }

  openWidgetDeletePopup = () => {
    if (!this.props.isFreezeDS) {
      this.setState({
        ...this.state,
        openDeleteModelFlag: true,
      });
    }
  };
  closeWidgetDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
    });
  };

  removeWidget = async (data) => {
    try {
      const requestParams = {
        DeletedBy: data.widgetId || this.props.reportId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteWidget(requestParams);
      if (response.status === 200) {
        toastr.success(response.message);
        this.closeWidgetDeletePopup();
        this.props.selectedDB(true);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  shareFile = (widgetId) => {
    this.state.taskList.map((riskReg) => {
      riskReg["isClosed"] = riskReg.isClosed ? "Open" : "Closed";
      Object.keys(riskReg).map(function (field) {
        if (RiskColumns.hasOwnProperty(field)) {
          if (riskReg.riskAlertStakeHolders) {
            riskReg["riskAlertStakeHolders"] =
              riskReg["riskAlertStakeHolders"].toString();
          }
        } else {
          //Custom field
          let arr = riskReg.customFields ? riskReg.customFields : [];
          let temp = arr.find((item) => item.fieldName == field);
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              riskReg[field] = temp.selectedCustomFieldNames.toString();
            } else if (temp.inputType === "Single Drop Down") {
              riskReg[field] = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
            } else if (temp.inputType === "Free Text") {
              riskReg[field] = temp.multiText;
            } else if (temp.inputType === "Numeric") {
              riskReg[field] = temp.multiText ? parseInt(temp.multiText) : "";
            } else if (temp.inputType === "Date") {
              riskReg[field] = temp.multiText
                ? new Date(temp.multiText)
                : undefined;
            }
          } else {
            //Imapct value
            let arrImp = riskReg.impactResponse ? riskReg.impactResponse : [];
            let imp = arrImp.find((item) => item.name == field);
            if (imp) {
              let str = imp.value.split("_");
              riskReg[field] = str[0] + "(" + str[1] + ")";
            }
          }
        }
      });
    });
    this._exporterRisk.current
      .toDataURL(this.state.taskList)
      .then((dataURL) => {
        this.sendMail(dataURL, widgetId);
      });
  };

  sendMail = async (dataURL, widgetId) => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "Bar-chart";
    const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");

    var file = this.dataURLtoFile(dataURL, widgetName + ".xlsx");
    var fd = new FormData(document.forms[0]);
    fd.append("file", file);
    fd.append("mailId", this.state.emailId);
    fd.append("message", this.state.message);
    fd.append("widgetId", widgetId);
    fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
    fd.append("CreatedDate", CreatedDate);
    fd.append("name", secureLocalStorage.getItem("userName"));
    fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
    this.setState({ ...this.state, loader: true });
    let response = await Api.shareWidgetToUser(fd);
    if (response.status === 200) {
      this.setState({ ...this.state, loader: false, emailId: "", message: "" });
      toastr.success(response.message);
    } else {
      this.setState({ ...this.state, loader: false });
      toastr.error(response.message);
    }
  };

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  //Excel
  onExportExcelClick = () => {
    this.state.taskList.map((riskReg) => {
      riskReg["isClosed"] = riskReg.isClosed ? "Open" : "Closed";
      Object.keys(riskReg).map(function (field) {
        if (RiskColumns.hasOwnProperty(field)) {
          if (riskReg.riskAlertStakeHolders) {
            riskReg["riskAlertStakeHolders"] =
              riskReg["riskAlertStakeHolders"].toString();
          }
        } else {
          //Custom field
          let arr = riskReg.customFields ? riskReg.customFields : [];
          let temp = arr.find((item) => item.fieldName == field);
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              riskReg[field] = temp.selectedCustomFieldNames.toString();
            } else if (temp.inputType === "Single Drop Down") {
              riskReg[field] = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
            } else if (temp.inputType === "Free Text") {
              riskReg[field] = temp.multiText;
            } else if (temp.inputType === "Numeric") {
              riskReg[field] = temp.multiText ? parseInt(temp.multiText) : "";
            } else if (temp.inputType === "Date") {
              riskReg[field] = temp.multiText
                ? new Date(temp.multiText)
                : undefined;
            }
          } else {
            //Imapct value
            let arrImp = riskReg.impactResponse ? riskReg.impactResponse : [];
            let imp = arrImp.find((item) => item.name == field);
            if (imp) {
              let str = imp.value.split("_");
              riskReg[field] = str[0] + "(" + str[1] + ")";
            }
          }
        }
      });
    });

    this._exporterRisk.current.save(this.state.taskList);
  };

  pdfTitlePopupClose = () => {
    this.setState({
      ...this.state,
      openPdfTitlePopup: false,
      title: "",
      isHidden: false,
    });
  };
  pdfTitlePopupOpen = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        openPdfTitlePopup: false,
        title: "",
        isHidden: false,
      });
    }, 1000);
  };
  onPDFExportClick = () => {
    if (this.gridPDFExport) {
      this.gridPDFExport.save();
    }
    this.pdfTitlePopupClose();
  };

  moveToHome = async (data) => {
    try {
      var req = {
        Enable: true,
        WidgetId: data.widgetId,
        CreatedBY: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  onEditCell() {}
  refreshTextNarative = (text, widgetId) => {
    this.props.refreshTextNarative &&
      this.props.refreshTextNarative(text, widgetId);
  };
    editWidgetOpen = (data) => {
    this.refs.childUpdateWidget.editWidgetdOpen(data);
  };
  updateChartData = async (data) => {
    await this.fetchReportsByPagination(data.dashboardId, data.widgetId);
    this.refs.childUpdateWidget.updateReportPopupClose();
  };
  render() {
    const chartData = this.state.chartData ? this.state.chartData : {};
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const CreatedDate = moment(chartData.createdDate).format("DD-MMM-yyyy");
    let isPrime = secureLocalStorage.getItem("isPrime") === true ? true : false;
    if (!this.state.isReportLoaded) {
      return <SkeletonReport />;
    } else {
      return (
        <div id="capture">
          {this.props.expandIcon && (
            <div className="expandView">
              <a
                className="expand"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.VIEWFULLVIEW} alt="Expand" width="10" />
              </a>
              <a
                className="shrink"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.SHRINK} alt="Expand" width="10" />
              </a>
            </div>
          )}
          {this.props.flag ? (
            <ul className="WidgetActions">
                {this.props.isTenentAdmin ||
                            chartData.createdBy == userId ||
                            (this.props.selectedDashboard &&
                              this.props.selectedDashboard.createdBy == userId)
                              ? !this.props.isFreezeDS && (
                                  <li onClick={() => this.editWidgetOpen(chartData)}>
                                    <a>
                                      <img src={Images.EDITICON} alt="Edit" width="14" />
                                    </a>
                                  </li>
                                )
                              : ""}
              <TextNarrative
                chartInputs={chartData}
                refreshTextNarative={this.refreshTextNarative}
                isFreezeDS={this.props.isFreezeDS}
              />
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li
                  title="Add to home"
                  onClick={() => this.moveToHome(chartData)}
                >
                  <a>
                    <img src={Images.HOME} alt="Download" width="14" />
                  </a>
                </li>
              )}

              <li onClick={this.onExportExcelClick}>
                <a>
                  <img src={Images.XLSX} alt="Download" width="14" />
                </a>
              </li>
              {/* <li onClick={this.pdfTitlePopupOpen}>
              <a>
                <img src={Images.PDF} alt="Download" width="14" />
              </a>
            </li> */}
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li onClick={() => this.openAddToCart(chartData.dataSourceId)}>
                  <a>
                    <img src={Images.SHARE} alt="Download" width="14" />
                  </a>
                </li>
              )}
              <li>
                <Dropdown
                  menuAlign="right"
                  title="Mail"
                  id="dropdown-menu-align-right"
                >
                  <Dropdown.Toggle>
                    <a>
                      <img src={Images.EMAIL} alt="Share" width="14" />
                    </a>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="filterList emailBox">
                    <div className="filterBox">
                      <div className="dateRange">
                        <div className="dateCont">
                          <h6>Email</h6>
                          <input
                            type="email"
                            autoComplete="off"
                            value={this.state.emailId}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                emailId: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="dateCont">
                          <h6>Message</h6>
                          <textarea
                            value={this.state.message}
                            autoComplete="off"
                            onChange={(e) =>
                              this.setState({
                                message: e.target.value,
                              })
                            }
                          ></textarea>
                          <Dropdown.Item
                            as="button"
                            onClick={() => this.shareFile(chartData.widgetId)}
                          >
                            SEND
                          </Dropdown.Item>
                        </div>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </li>

              {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                    <li onClick={this.openWidgetDeletePopup}>
                      <a className="bgRed">
                        <img src={Images.TRASH} alt="Trash" width="13" />
                      </a>
                    </li>
                  )
                : ""}
            </ul>
          ) : (
            <ul className="WidgetActions">
              {/* <li
              title="Remove from home"
              onClick={() => this.removeFromHome(chartData)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li> */}
            </ul>
          )}

          <div
            id={"c" + chartData.widgetId}
            className="tblCont riskRegister dataGrids reportsGrid"
            key={chartData.title}
          >
            <div className="titleBG">
              <span>{chartData.title}</span>
              {/* <small className="createdDate">{CreatedDate}</small> */}
            </div>
            <ExcelExport
              data={this.state.taskList}
              fileName={
                chartData.widgetName
                  ? chartData.widgetName.replace(".", " ")
                  : "Tasks" + ".xlsx"
              }
              ref={this._exporterRisk}
              headerPaddingCellOptions={{
                background: "#ff0000",
              }}
            >
              <Grid
                style={{ minHeight: "100px" }}
                data={process(this.state.taskList, this.state.dataState)}
                {...this.state.dataState}
                reorderable
                resizable
                sortable={true}
                pageable={true}
                onDataStateChange={(e) => {
                  this.setState({ dataState: e.dataState });
                }}
              >
                <GridNoRecords>
                  {chartData.notValidPrimeDataset
                    ? "Cannot load dataset as Prime settings have been changed for Tenant or Workstream"
                    : chartData.isCustomFieldDeleted
                    ? "Associated Dataset's Custom fields might been deleted or revoked"
                    : chartData.isImpactDeleted
                    ? "Associated Dataset's Impact fields might been deleted or revoked"
                    : chartData.isTaskModuleDisabled
                    ? "Cannot load report as Task Module settings have been changed for Tenant. Please contact administrator."
                    : "No records available"}
                </GridNoRecords>

                <Column
                  field="organizationUnitName"
                  title="Workstream"
                  width="200px"
                />
                <Column field="taskNumber" title="Task Number" width="200px" />
                {/* <Column field="isApproved" title="Approved" width="200px" /> */}
                <Column field="taskTitle" title="Task Title" width="200px" />
                <Column
                  field="taskDescription"
                  title="Task Description"
                  width="200px"
                />
                <Column
                  field="cost"
                  title={
                    "Total Cost " +
                    " (" +
                    secureLocalStorage.getItem("currency") +
                    ")"
                  }
                  width="200px"
                />
                <Column
                  field="approvedCost"
                  title={
                    "Approved Cost " +
                    " (" +
                    secureLocalStorage.getItem("currency") +
                    ")"
                  }
                  width="200px"
                />
                <Column
                  field="effort"
                  title={"Total Effort" + " (Days)"}
                  width="200px"
                />
                <Column
                  field="approvedEffort"
                  title={"Approved Effort" + " (Days)"}
                  filter={"numeric"}
                  width="200px"
                />
                <Column
                  field="percentageOnTrack"
                  title="% on Track"
                  width="200px"
                />
                <Column
                  field="percentageCompletion"
                  title="% Completion"
                  width="200px"
                />
                <Column
                  field="priorityRankingName"
                  title="Priority Ranking"
                  width="200px"
                />
                <Column
                  field="progressComment"
                  title="progress Status"
                  width="200px"
                  cell={(props) => (
                    <td title={props.dataItem.progressComment}>
                      {props.dataItem.progressComment}
                    </td>
                  )}
                />
                {this.state.dropdownColumns}
                <Column
                  field="originalCompletionDate"
                  title="Original Completion Date"
                  width="200px"
                />
                <Column
                  field="projectedCompletionDate"
                  title="Projected Completion Date"
                  width="200px"
                />
                <Column
                  field="actualCompletionDate"
                  title="Actual Completion Date"
                  width="200px"
                />
                <Column
                  field="proximityAlertDate"
                  title="Proximity Alert Date"
                  width="200px"
                />
                <Column
                  field="daysOverdue"
                  title="Original Days Overdue"
                  width="120px"
                />
                <Column
                  field="projectedDaysOverdue"
                  title="Projected Days Overdue"
                  width="120px"
                />
                {/* <Column
                  field="alertStakeHolders"
                  title="Alert Stakeholders"
                  width="200px"
                />
                <Column
                  field="alertDescription"
                  title="Alert Description"
                  width="200px"
                /> */}
                <Column
                  field="taskOwnerName"
                  title="Task Owner"
                  width="200px"
                />
                <Column
                  field="taskFieldCompletion"
                  title="% of fields completed"
                  width="120px"
                />
                <Column
                  field="createdDate"
                  title="Created Date"
                  width="200px"
                />
                <Column
                  field="createdByName"
                  title="Created By"
                  width="200px"
                />
                <Column
                  field="updatedDate"
                  title="Updated Date"
                  width="200px"
                />
                <Column
                  field="updatedByName"
                  title="Updated By"
                  width="200px"
                />
                <Column
                  field="closedDate"
                  title="Closed Date"
                  width="200px"
                  filter={"date"}
                />
                <Column field="isClosed" title="Status" width="200px" />
              </Grid>
            </ExcelExport>

            <GridPDFExport
              ref={(pdfExport) => (this.gridPDFExport = pdfExport)}
              fileName={chartData.widgetName ? chartData.widgetName : "Task"}
              margin="1cm"
              date={new Date()}
              // paperSize={["1000mm", "400mm"]}
              paperSize={"auto"}
              title={this.state.title + " " + CreatedDate}
              repeatHeaders={true}
            >
              <Grid
                style={{ minHeight: "100px" }}
                data={process(this.state.taskList, this.state.dataState)}
                {...this.state.dataState}
                reorderable
                resizable
                sortable={true}
                pageable={true}
                onDataStateChange={(e) => {
                  this.setState({ dataState: e.dataState });
                }}
              >
                <GridNoRecords>
                  {chartData.notValidPrimeDataset
                    ? "Cannot load dataset as Prime settings have been changed for Tenant or Workstream"
                    : chartData.isCustomFieldDeleted
                    ? "Associated Dataset's Custom fields might been deleted or revoked"
                    : chartData.isImpactDeleted
                    ? "Associated Dataset's Impact fields might been deleted or revoked"
                    : chartData.isTaskModuleDisabled
                    ? "Cannot load report as Task Module settings have been changed for Tenant. Please contact administrator."
                    : "No records available"}
                </GridNoRecords>

                <Column
                  field="organizationUnitName"
                  title="Workstream"
                  width="200px"
                />
                <Column field="taskNumber" title="Task Number" width="200px" />
                {/* <Column field="isApproved" title="Approved" width="200px" /> */}
                <Column field="taskTitle" title="Task Title" width="200px" />
                <Column
                  field="taskDescription"
                  title="Task Description"
                  width="200px"
                />
                <Column
                  field="cost"
                  title={
                    "Total Cost " +
                    " (" +
                    secureLocalStorage.getItem("currency") +
                    ")"
                  }
                  width="200px"
                />
                <Column
                  field="approvedCost"
                  title={
                    "Approved Cost " +
                    " (" +
                    secureLocalStorage.getItem("currency") +
                    ")"
                  }
                  width="200px"
                />
                <Column
                  field="effort"
                  title={"Total Effort" + " (Days)"}
                  width="200px"
                />
                <Column
                  field="approvedEffort"
                  title={"Approved Effort" + " (Days)"}
                  filter={"numeric"}
                  width="200px"
                />
                <Column
                  field="percentageOnTrack"
                  title="% on Track"
                  width="200px"
                />
                <Column
                  field="percentageCompletion"
                  title="% Completion"
                  width="200px"
                />
                <Column
                  field="priorityRankingName"
                  title="Priority Ranking"
                  width="200px"
                />
                <Column
                  field="progressComment"
                  title="progress Status"
                  width="200px"
                  cell={(props) => (
                    <td title={props.dataItem.progressComment}>
                      {props.dataItem.progressComment}
                    </td>
                  )}
                />
                {this.state.dropdownColumns}
                <Column
                  field="originalCompletionDate"
                  title="Original Completion Date"
                  width="200px"
                />
                <Column
                  field="projectedCompletionDate"
                  title="Projected Completion Date"
                  width="200px"
                />
                <Column
                  field="actualCompletionDate"
                  title="Actual Completion Date"
                  width="200px"
                />
                <Column
                  field="proximityAlertDate"
                  title="Proximity Alert Date"
                  width="200px"
                />
                <Column
                  field="daysOverdue"
                  title="Original Days Overdue"
                  width="120px"
                />
                <Column
                  field="projectedDaysOverdue"
                  title="Projected Days Overdue"
                  width="120px"
                />
                {/* <Column
                  field="alertStakeHolders"
                  title="Alert Stakeholders"
                  width="200px"
                />
                <Column
                  field="alertDescription"
                  title="Alert Description"
                  width="200px"
                /> */}
                <Column
                  field="taskOwnerName"
                  title="Task Owner"
                  width="200px"
                />
                <Column
                  field="taskFieldCompletion"
                  title="% of fields completed"
                  width="120px"
                />
                <Column
                  field="createdDate"
                  title="Created Date"
                  width="200px"
                />
                <Column
                  field="createdByName"
                  title="Created By"
                  width="200px"
                />
                <Column
                  field="updatedDate"
                  title="Updated Date"
                  width="200px"
                />
                <Column
                  field="updatedByName"
                  title="Updated By"
                  width="200px"
                />
                <Column
                  field="closedDate"
                  title="Closed Date"
                  width="200px"
                  filter={"date"}
                />
                <Column field="isClosed" title="Status" width="200px" />
              </Grid>
            </GridPDFExport>
            <div className="wgHeader">
              <h4>Dataset: {chartData.dataSource} </h4>
            </div>
            <TextNarrativeExport
              chartData={chartData}
              isHidden={this.state.isHidden}
            />
          </div>
  <ReportUpdate
            chartData={chartData}
            ref="childUpdateWidget"
            updateChartData={this.updateChartData}
          />
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>

          <Popup
            show={this.state.openPdfTitlePopup}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}

            <div className="addTypeForm">
              <div className="fieldCont">
                <label>Enter Title</label>
                <input
                  type="text"
                  onChange={(e) => this.setState({ title: e.target.value })}
                  placeholder="Title"
                  value={this.state.title}
                  required
                />
              </div>
              <div className="btnGroup">
                <button
                  disabled={!this.state.title}
                  className="btnPrimary"
                  onClick={this.onPDFExportClick}
                >
                  Export
                </button>
                <button className="btnDark" onClick={this.pdfTitlePopupClose}>
                  Cancel
                </button>
              </div>
            </div>
          </Popup>

          <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
            <AddToCart
              {...this.props}
              closeAddToCart={() => this.closeAddToCart()}
              cartViewDetailsId={this.state.cartViewDetails}
              cartViewType={this.state.cartViewType}
            />
          </Popup>
        </div>
      );
    }
  }
}
